"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequireEmailIntegration = exports.TeamListAdminOptions = void 0;
var TeamListAdminOptions;
exports.TeamListAdminOptions = TeamListAdminOptions;

(function (TeamListAdminOptions) {
  TeamListAdminOptions[TeamListAdminOptions["AllTeams"] = 0] = "AllTeams";
  TeamListAdminOptions[TeamListAdminOptions["OnlyAdmins"] = 1] = "OnlyAdmins";
})(TeamListAdminOptions || (exports.TeamListAdminOptions = TeamListAdminOptions = {}));

var RequireEmailIntegration;
exports.RequireEmailIntegration = RequireEmailIntegration;

(function (RequireEmailIntegration) {
  RequireEmailIntegration["Show"] = "show";
  RequireEmailIntegration["NotShow"] = "not_show";
  RequireEmailIntegration["Required"] = "required";
})(RequireEmailIntegration || (exports.RequireEmailIntegration = RequireEmailIntegration = {}));